module.exports = __webpack_public_path__ + "static/media/donasi4.cfde27b8.jpg";